import React from 'react';
import Row from '@amzn/meridian/row';
import VolumeTargetCard from './VolumeTargetCard';
import { VolumeTargetComparisonData } from '../model';
import { VolumeTargetType } from '../constants';

interface VolumeTargetCardsRowProps {
    volumeTargetComparisons?: VolumeTargetComparisonData[];
}

const VolumeTargetCardsRow: React.FC<VolumeTargetCardsRowProps> = ({ volumeTargetComparisons }) => {
    const alps = volumeTargetComparisons?.find(v => v.targetType === VolumeTargetType.ALPS_TARGET);
    const pgBase = volumeTargetComparisons?.find(v => v.targetType === VolumeTargetType.PRIMARY_GRADING_TARGET);
    const pgOverride = volumeTargetComparisons?.find(v => v.targetType === VolumeTargetType.OVERRIDDEN_PRIMARY_GRADING_TARGET);

    return (
        <Row spacing="400" widths={["grid-6", "grid-6"]}>
            <VolumeTargetCard
                label="ALPS Volume Target"
                targetValue={alps?.targetValue ?? null}
                actualValue={alps?.actualValue ?? null}
            />
            <VolumeTargetCard
                label="Primary Grading Target"
                targetValue={pgBase?.targetValue ?? null}
                actualValue={pgBase?.actualValue ?? null}
                overrideTargetValue={pgOverride?.targetValue}
                overrideLabel="Override Target"
            />
        </Row>
    );
};

export default VolumeTargetCardsRow;
